import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import translation files
import frTranslations from './locales/fr.json';
import enTranslations from './locales/en.json';

const resources = {
  fr: {
    translation: frTranslations,
  },
  en: {
    translation: enTranslations,
  },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    lng: 'fr', // Default language (French)
    fallbackLng: 'fr', // Fallback to French if detection fails
    
    detection: {
      // Order of language detection methods
      order: ['localStorage', 'navigator', 'htmlTag'],
      // Cache user language
      caches: ['localStorage'],
      // Don't cache if we're in development
      excludeCacheFor: ['cimode'],
    },

    interpolation: {
      escapeValue: false, // React already does escaping
    },

    // Namespace separation
    keySeparator: '.',
    nsSeparator: ':',

    // Debug mode (disable in production)
    debug: import.meta.env.DEV,

    // React options
    react: {
      useSuspense: false, // Disable suspense to avoid loading issues
    },
  });

export default i18n;

// Export types for better TypeScript support
export type Language = 'fr' | 'en';

export const supportedLanguages: { code: Language; name: string; nativeName: string }[] = [
  { code: 'fr', name: 'French', nativeName: 'Français' },
  { code: 'en', name: 'English', nativeName: 'English' },
];